// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-block {
  width: 100%;
}

.alert-danger {
  margin-top: 10px;
}

.float-right {
  float: right;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.goto-btn {
  background-color: #ff6636 !important;
  padding: 0px 24px 0px 24px;
  border: none !important;
  border-radius: 0px solid #ff6636;
}

.payment-success-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}
.payment-success-page .success-icon-container {
  margin-bottom: 30px;
}
.payment-success-page .success-icon-container .success-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border-radius: 50%;
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
  animation: successPulse 2s infinite;
}
.payment-success-page .success-icon-container .success-icon svg {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}
.payment-success-page .success-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #28a745;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.payment-success-page .success-message {
  max-width: 600px;
  margin-bottom: 30px;
}
.payment-success-page .success-message .response-message {
  font-size: 18px;
  color: #495057;
  background: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 12px;
  border-left: 4px solid #28a745;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  margin-bottom: 15px;
  font-weight: 500;
}
.payment-success-page .success-message .default-message {
  font-size: 16px;
  color: #6c757d;
  background: rgba(255, 255, 255, 0.7);
  padding: 15px;
  border-radius: 8px;
  margin: 0;
  font-style: italic;
}
.payment-success-page .success-illustration {
  margin-bottom: 30px;
}
.payment-success-page .success-illustration .success-image {
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
.payment-success-page .success-illustration .success-image:hover {
  transform: scale(1.02);
}
.payment-success-page .success-actions {
  margin-bottom: 30px;
}
.payment-success-page .success-actions .dashboard-button {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  padding: 15px 30px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 250px;
  color: white;
  transition: all 0.3s ease;
}
.payment-success-page .success-actions .dashboard-button:hover {
  background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);
  color: white;
}
.payment-success-page .success-actions .dashboard-button:active {
  transform: translateY(-1px);
}
.payment-success-page .success-actions .dashboard-button:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.payment-success-page .success-help .help-text {
  font-size: 16px;
  color: #6c757d;
  font-weight: 500;
  margin: 0;
  opacity: 0.9;
}

@keyframes successPulse {
  0% {
    transform: scale(1);
    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 35px rgba(40, 167, 69, 0.4);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
  }
}
@media (max-width: 768px) {
  .payment-success-page {
    padding: 15px;
  }
  .payment-success-page .success-icon-container .success-icon {
    width: 100px;
    height: 100px;
  }
  .payment-success-page .success-icon-container .success-icon svg {
    width: 60px;
    height: 60px;
  }
  .payment-success-page .success-title {
    font-size: 2rem;
  }
  .payment-success-page .success-message .response-message {
    font-size: 16px;
    padding: 15px;
  }
  .payment-success-page .success-message .default-message {
    font-size: 14px;
    padding: 12px;
  }
  .payment-success-page .success-illustration .success-image {
    width: 250px;
    height: 250px;
  }
  .payment-success-page .success-actions .dashboard-button {
    padding: 12px 24px;
    font-size: 16px;
    min-width: 220px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/PaymentForm/PaymentForm.scss"],"names":[],"mappings":"AAIA;EACE,WAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,6BAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,gCAAA;AAHF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,6DAAA;AAJF;AAME;EACE,mBAAA;AAJJ;AAMI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,6DAAA;EACA,kBAAA;EACA,6CAAA;EACA,mCAAA;AAJN;AAMM;EACE,iDAAA;AAJR;AASE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yCAAA;AAPJ;AAUE;EACE,gBAAA;EACA,mBAAA;AARJ;AAUI;EACE,eAAA;EACA,cAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yCAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AARN;AAWI;EACE,eAAA;EACA,cAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AATN;AAaE;EACE,mBAAA;AAXJ;AAaI;EACE,mBAAA;EACA,yCAAA;EACA,+BAAA;AAXN;AAaM;EACE,sBAAA;AAXR;AAgBE;EACE,mBAAA;AAdJ;AAgBI;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AAdN;AAgBM;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;EACA,YAAA;AAdR;AAiBM;EACE,2BAAA;AAfR;AAkBM;EACE,gDAAA;AAhBR;AAsBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;AApBN;;AA0BA;EACE;IACE,mBAAA;IACA,6CAAA;EAvBF;EAyBA;IACE,sBAAA;IACA,8CAAA;EAvBF;EAyBA;IACE,mBAAA;IACA,6CAAA;EAvBF;AACF;AA2BA;EACE;IACE,aAAA;EAzBF;EA4BI;IACE,YAAA;IACA,aAAA;EA1BN;EA4BM;IACE,WAAA;IACA,YAAA;EA1BR;EA+BE;IACE,eAAA;EA7BJ;EAiCI;IACE,eAAA;IACA,aAAA;EA/BN;EAkCI;IACE,eAAA;IACA,aAAA;EAhCN;EAqCI;IACE,YAAA;IACA,aAAA;EAnCN;EAwCI;IACE,kBAAA;IACA,eAAA;IACA,gBAAA;EAtCN;AACF","sourcesContent":[".form-control {\n  // margin-bottom: 10px;\n}\n\n.btn-block {\n  width: 100%;\n}\n\n.alert-danger {\n  margin-top: 10px;\n}\n\n.float-right {\n  float: right;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.goto-btn {\n  background-color: #ff6636 !important;\n  padding: 0px 24px 0px 24px;\n  border: none !important;\n  border-radius: 0px solid #ff6636;\n}\n\n// Payment Success Page Styles\n.payment-success-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  text-align: center;\n  padding: 20px;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n\n  .success-icon-container {\n    margin-bottom: 30px;\n\n    .success-icon {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 120px;\n      height: 120px;\n      background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n      border-radius: 50%;\n      box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);\n      animation: successPulse 2s infinite;\n\n      svg {\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n      }\n    }\n  }\n\n  .success-title {\n    font-size: 2.5rem;\n    font-weight: 800;\n    color: #28a745;\n    margin-bottom: 20px;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  .success-message {\n    max-width: 600px;\n    margin-bottom: 30px;\n\n    .response-message {\n      font-size: 18px;\n      color: #495057;\n      background: rgba(255, 255, 255, 0.9);\n      padding: 20px;\n      border-radius: 12px;\n      border-left: 4px solid #28a745;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n      backdrop-filter: blur(10px);\n      margin-bottom: 15px;\n      font-weight: 500;\n    }\n\n    .default-message {\n      font-size: 16px;\n      color: #6c757d;\n      background: rgba(255, 255, 255, 0.7);\n      padding: 15px;\n      border-radius: 8px;\n      margin: 0;\n      font-style: italic;\n    }\n  }\n\n  .success-illustration {\n    margin-bottom: 30px;\n\n    .success-image {\n      border-radius: 16px;\n      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n      transition: transform 0.3s ease;\n\n      &:hover {\n        transform: scale(1.02);\n      }\n    }\n  }\n\n  .success-actions {\n    margin-bottom: 30px;\n\n    .dashboard-button {\n      background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n      border: none;\n      padding: 15px 30px;\n      font-size: 18px;\n      font-weight: 600;\n      border-radius: 12px;\n      box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 250px;\n      color: white;\n      transition: all 0.3s ease;\n\n      &:hover {\n        background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);\n        transform: translateY(-3px);\n        box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);\n        color: white;\n      }\n\n      &:active {\n        transform: translateY(-1px);\n      }\n\n      &:focus {\n        box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n      }\n    }\n  }\n\n  .success-help {\n    .help-text {\n      font-size: 16px;\n      color: #6c757d;\n      font-weight: 500;\n      margin: 0;\n      opacity: 0.9;\n    }\n  }\n}\n\n// Animation for the success icon\n@keyframes successPulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 12px 35px rgba(40, 167, 69, 0.4);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);\n  }\n}\n\n// Responsive design for success page\n@media (max-width: 768px) {\n  .payment-success-page {\n    padding: 15px;\n\n    .success-icon-container {\n      .success-icon {\n        width: 100px;\n        height: 100px;\n\n        svg {\n          width: 60px;\n          height: 60px;\n        }\n      }\n    }\n\n    .success-title {\n      font-size: 2rem;\n    }\n\n    .success-message {\n      .response-message {\n        font-size: 16px;\n        padding: 15px;\n      }\n\n      .default-message {\n        font-size: 14px;\n        padding: 12px;\n      }\n    }\n\n    .success-illustration {\n      .success-image {\n        width: 250px;\n        height: 250px;\n      }\n    }\n\n    .success-actions {\n      .dashboard-button {\n        padding: 12px 24px;\n        font-size: 16px;\n        min-width: 220px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
